function connectMegaMenu() {
  var megaMenus = document.querySelectorAll('.mega-menu[data-class]');

  megaMenus.forEach(function (megaMenu) {
    var connectKey = megaMenu.getAttribute('data-class');

    var targetMega = megaMenu.querySelector('.mega-wrapper');
    var sourceMega = document.querySelector(
      '.connect-mega[data-class="' + connectKey + '"]'
    );

    if (!targetMega || !sourceMega) return;

    targetMega.innerHTML = sourceMega.innerHTML;
  });
}
function init() {
  connectMegaMenu();
}
document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);
document.addEventListener('shopify:section:select', init);
